import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "navigation-button",
  templateUrl: "./navigation-button.component.html",
  styleUrl: "./navigation-button.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavigationButtonComponent {
  private router = inject(Router);

  public routhPath = input.required<string>();

  public navigate() {
    this.router.navigate([`/${this.routhPath()}`], {
      queryParamsHandling: "merge",
    });
  }
}
